import { from } from "rxjs";
import { ignoreElements, mergeMap } from "rxjs/operators";
import { endWith } from "./endWith";
export function mergeTap(next) {
    return (source) => source.pipe(mergeMap((value) => from(next(value)).pipe(ignoreElements(), endWith(value))));
}
//# sourceMappingURL=mergeTap.js.map